import {
  CustomFieldExtensionSchema,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';

export const schema: CustomFieldExtensionSchema = {
  uiOptions: {
    type: 'object',
    required: ['title', 'description'],
    properties: {
      title: {
        type: 'string',
        description: 'The label of the repo name field',
      },
      description: {
        type: 'string',
        description: 'The sublabel or description of the repo name field',
      },
    },
  },
  returnValue: {
    type: 'string',
  },
};

export type Options = {
  allowedOwners: string[];
  allowedProjects: string[];
  title: string;
  description: string;
  repoNameProperty?: string;
};

export type FieldProps = FieldExtensionComponentProps<string, Options>;
